import { useCallback } from "react";

/**
 * Custom hook to interpolate a string with dynamic values.
 * @returns A function that takes a template string and values to interpolate.
 */

const useStringInterpolation = () => {
   const interpolate = useCallback((template, values) => {
     return template.replace(/\{(\w+)\}/g, (_, key) => values[key] ?? "");
   }, []);

   return interpolate;
};

export default useStringInterpolation;
